import { Component, inject } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Environment } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService, DIALOG_DATA } from '@hyperkit'

import { EnvironmentService } from '../../../../shared/services/environment.service'

@Component({
  standalone: false,
  selector: 'delete-environment-dialog',
  templateUrl: './delete-environment-dialog.component.html',
  styleUrls: ['./delete-environment-dialog.component.scss'],
})
export class DeleteEnvironmentDialogComponent {
  dialogRef = inject(DialogRef)
  dialogService = inject(DialogService)
  environmentService = inject(EnvironmentService)
  environment = inject<Environment>(DIALOG_DATA, { optional: true })

  public formGroup: FormGroup
  public error: string

  public onSubmit(): void {
    this.environmentService.deleteEnvironment(this.environment.id).subscribe(
      () => {
        this.dialogRef.close(this.environment)
      },
      (error) => {
        this.error = error.message
      },
    )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
